import type { ChartAxisX } from '@/admin/dashboards/chartViewModel';

/** X tick label for attempt-number score progression. */
export function formatScoreAttemptAxis(x: ChartAxisX): string {
  return String(x);
}

const DAY_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

function calendarDay(iso: string): Date | undefined {
  const match = DAY_PREFIX.exec(iso);
  if (!match) return undefined;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? undefined : date;
}

function formatCalendarDay(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * Mondays whose date falls inside the selected range.
 * A week with no sessions still belongs on the helpfulness axis.
 */
export function mondaysInsideRange(fromIso: string, toIso: string): string[] {
  const from = calendarDay(fromIso);
  const to = calendarDay(toIso);
  if (!from || !to) return [];
  const start = from.getTime() <= to.getTime() ? from : to;
  const end = from.getTime() <= to.getTime() ? to : from;
  const cursor = new Date(start);
  const daysUntilMonday = (8 - cursor.getDay()) % 7;
  cursor.setDate(cursor.getDate() + daysUntilMonday);
  const mondays: string[] = [];
  while (cursor.getTime() <= end.getTime()) {
    mondays.push(formatCalendarDay(cursor));
    cursor.setDate(cursor.getDate() + 7);
  }
  return mondays;
}

/** X tick label for weekly helpfulness bars. */
export function formatChartWeekAxis(x: ChartAxisX): string {
  const raw = String(x);
  const d = new Date(raw.slice(0, 10));
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

/** X tick label for session-week score progression (ordinal week 1, 2, 3 — not calendar dates). */
export function formatScoreSessionWeekAxis(x: ChartAxisX): string {
  return formatScoreAttemptAxis(x);
}
